<template>
  <v-row
    class="my-16"
    :class="{ 'px-8 subtitle-2': $vuetify.breakpoint.lgAndDown }"
    align="start"
    justify="center"
  >
    <v-col class="teaser" cols="12" sm="12" md="12" lg="12" xl="12">
      <v-card-text
        v-editable="blok"
        class="pa-0 pb-3 font-weight-light text-center display-2 teaser__inner"
        :class="{ 'display-1': $vuetify.breakpoint.mdAndDown }"
      >
        {{ blok.headline }}
      </v-card-text>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ["blok"]
};
</script>
